import { SectionType } from 'features/libra/sections/sectionTypes'

import { ConditionalFormConfig } from './api/conditionalFormApi'
import { getVisibleSectionIds } from './conditionalFormSection/conditionalFormVisibility'

type FieldValuesType = Record<string, unknown>

export function isConditionalFormStepComplete(params: {
  config: ConditionalFormConfig
  fieldValues: FieldValuesType
}): boolean {
  const { config, fieldValues } = params
  const { form, sections } = config
  const visibleSectionIds = getVisibleSectionIds(form, fieldValues ?? {})

  return visibleSectionIds.every((sectionId) => {
    const section = sections.find((s) => s.id === sectionId)
    if (!section) {
      return true
    }

    // Use switch on section.type for strong typing
    switch (section.type) {
      case SectionType.FLOWCHART: {
        // Flowchart sections are complete when their result field is set
        const flowchartValue = fieldValues?.[section.id]
        return flowchartValue !== undefined && flowchartValue !== null
      }

      case SectionType.FORM:
        // Regular form sections: check all fields are filled
        return section.fields.every((field: string) => {
          const value = fieldValues?.[field]
          return value !== undefined && value !== null && value !== ''
        })
    }
  })
}
